<template>
  <div id="navigation">
    <v-navigation-drawer temporary absolute v-model="sideNav">
      <v-list>
        <v-list-tile v-for="item in menuItems" :key="item.title" :to="item.link" v-if="item.requireAuth == false || (item.requireAuth == true && isLoggedIn)" :class="(isLoggedIn && item.hideIfLoggedIn == true) ? 'hide' : ''">
          <v-list-tile-content>{{ item.title }}</v-list-tile-content>
        </v-list-tile>
        <div role="listitem" v-if="isLoggedIn">
          <a @click="logout" class="v-list__tile v-list__tile--link theme--light">
            <div class="v-list__tile__content">{{$t('Logout')}}</div>
          </a>
        </div>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar>
      <v-toolbar-side-icon @click.stop="sideNav = !sideNav" class="hidden-sm-and-up "></v-toolbar-side-icon>
      <v-toolbar-title>
          <a href="/" class="logo">
            <img src="../assets/logo.svg" id="logo" />
            <img src="../assets/logo-padelikeskus.svg" id="logo-padel" />
          </a>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-xs-only">
        <v-btn flat v-for="item in menuItems" :key="item.title" :to="item.link" v-if="item.requireAuth == false || (item.requireAuth == true && isLoggedIn)" :class="(isLoggedIn && item.hideIfLoggedIn == true) ? 'hide' : ''">
            <i :class="item.icon" v-if="item.icon"></i>
            {{ item.title }}
        </v-btn>
        <a @click="logout" class="v-btn v-btn--flat v-btn--router theme--light" v-if="isLoggedIn">{{$t('Logout')}}</a>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        sideNav: false,
        menuItems: [
          {"link":"/", "title": this.$t('Calendar'), "requireAuth": false, "class": false},
          {"link":"reservations", "title": this.$t('Reservations'), "requireAuth": true},
          {"link":"settings", "title": this.$t('Account'), icon: "fas fa-user-circle", "requireAuth": true},
          {"link":"login", "title": this.$t('Login'), "requireAuth": false, "hideIfLoggedIn": true},
          {"link":"register", "title": this.$t('Register'), "requireAuth": false, "hideIfLoggedIn": true}
        ]
      }
    },
    computed: {
      isLoggedIn : function(){ return this.$store.getters.isLoggedIn}
    },
    methods: {
      logout: function () {
        this.$store.dispatch('logout')
          .then(() => {
            this.$router.push('/login')
          })
      }
    },
    created: function () {
      let _this = this;
      this.$http.interceptors.response.use(undefined, function (err) {
        return new Promise(function (resolve, reject) {
          if (err.response.data.error === 'Provided token is expired.') {
              _this.$store.dispatch('logout');
              _this.$router.push('/login');
          }
          throw err;
        });
      });
    }
  }
</script>

<style lang="scss" scoped>
    .logo {
        display: inline-block; min-width: 140px;
        img {max-width: 100%; max-height: 50px; padding-top: 5px;}
    }
    #logo-padel {display: none;}
    .hide {display: none;}
    i {margin-right: 5px; font-size: 1.4rem;}
</style>



// WEBPACK FOOTER //
// src/views/Navbar.vue